import { useEffect, useState } from "react";
import { FileText, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { AssignmentFileLink } from "@/components/AssignmentFileLink";

const sizeLabel = (size = 0) => size >= 1024 * 1024
  ? `${(size / (1024 * 1024)).toFixed(1)} MB`
  : `${Math.max(1, Math.round(size / 1024))} KB`;

export const SubmissionAttachment = ({ file, index, prefix, canRemove = false, onRemove }) => {
  const [previewUrl, setPreviewUrl] = useState(file.file_data || "");

  useEffect(() => {
    if (file.file_data || !file.previewable || !file.file_id) return;
    let active = true;
    let url = "";
    api.get(`/assignment-files/${file.file_id}`, { responseType: "blob" }).then((response) => {
      if (!active) return;
      url = URL.createObjectURL(response.data);
      setPreviewUrl(url);
    }).catch(() => {});
    return () => { active = false; if (url) URL.revokeObjectURL(url); };
  }, [file.file_data, file.file_id, file.previewable]);

  return (
    <div data-testid={`${prefix}-attachment-${index}`} className="min-w-0 p-3 rounded-xl border border-slate-200 bg-white">
      {previewUrl ? (
        <img data-testid={`${prefix}-attachment-preview-${index}`} src={previewUrl} alt={file.file_name || "Submission attachment"}
          className="w-full aspect-[4/3] object-contain rounded-lg bg-slate-50 border border-slate-100 mb-2" />
      ) : (
        <div className="w-full aspect-[4/2] grid place-items-center rounded-lg bg-slate-50 text-slate-400 mb-2"><FileText size={26} /></div>
      )}
      <div className="text-xs text-slate-500 truncate" title={file.file_name}>{file.file_name}</div>
      <div className="text-[11px] text-slate-400 mb-2">{sizeLabel(file.size)}</div>
      <div className="flex items-center justify-between gap-2">
        <AssignmentFileLink file={file} testId={`${prefix}-attachment-download-${index}`} />
        {canRemove && <button type="button" data-testid={`${prefix}-attachment-remove-${index}`} onClick={()=>onRemove(file)}
          aria-label={`Remove ${file.file_name}`} className="text-red-700 hover:text-red-900"><Trash2 size={14} /></button>}
      </div>
    </div>
  );
};